module.exports = __webpack_public_path__ + "img/pr-13.9d98ba99.png";